/** 返回特定頁面 */
export function goPage(path: string): void {
  window.location.href = path
}
